import { render, staticRenderFns } from "./DocusignTemplateManagement.vue?vue&type=template&id=144a4b36&"
import script from "./DocusignTemplateManagement.vue?vue&type=script&lang=ts&"
export * from "./DocusignTemplateManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports